import { createFileRoute, redirect } from '@tanstack/react-router';

import { SiteSetupPage } from '@/pages/utils/SiteSetupPage.tsx';
import { useConfigStore } from '@/stores';

export const Route = createFileRoute('/(app)/utils/siteSetup')({
  // The setting is stored in cloud inventory, which only portable mode talks to.
  beforeLoad: () => {
    if (!useConfigStore.getState().portableMode) {
      throw redirect({ to: '/' });
    }
  },
  component: SiteSetupPage,
});
